import React from 'react'

import { Modal, Loading, Tooltip, MODAL_SIZE_XXL } from 'mailup-web-components'
import { useRecoilValue, useRecoilCallback } from 'recoil'

import { modalContentDialogCancelCallback } from './recoil/callbacks'
import { modalBeeContentDialogState } from './recoil/state'

import { Wizard, Panel } from './components/Wizard'
import LayoutConfig from './components/LayoutConfig'
import ContentsConfig from './components/ContentsConfig'

import styled from '@emotion/styled'

import './ModalBeeContentDialog.scss'

const StyledModal = styled(Modal)`
  &.b-modal {
    padding: 0;
  }

  & .b-modal__head {
    position: relative;
    padding-top: 30px;
  }

  & .b-modal__body {
    border-top: 1px solid var(--geyser);
    border-bottom: 1px solid var(--geyser);
  }

  & .b-modal__foot {
    padding-bottom: 20px;
    padding-left: 30px;
    padding-right: 30px;
  }

  & .b-modal__title {
    text-align: center;
  }
`

const ModalBeeContentDialog = () => {
  const { show, loading } = useRecoilValue(modalBeeContentDialogState)

  const handleClose = useRecoilCallback(modalContentDialogCancelCallback, [])

  return (
    <StyledModal
      show={show}
      size={MODAL_SIZE_XXL}
      containerClassName='c-modal-bee-content-dialog-container'
      showClose
      onClose={handleClose}
      closeOnOverlayClick={false}
    >
      <Loading open={loading} />
      <Tooltip />
      <Wizard steps={[1, 2]}>
        <Panel>
          <LayoutConfig />
        </Panel>
        <Panel>
          <ContentsConfig />
        </Panel>
      </Wizard>
    </StyledModal>
  )
}

export default ModalBeeContentDialog
